"use strict";
exports.__esModule = true;
exports.BasicChartComponent = exports.makeChart = exports.handleResponsiveNess = exports.loadSettings = exports.getDate = exports.exportHTML = exports.Component = exports.getDashStyles = exports.lightenDarkenColor = void 0;
var angular = require("angular");
function lightenDarkenColor(col, amt) {
    var usePound = false;
    if (col[0] == "#") {
        col = col.slice(1);
        usePound = true;
    }
    var num = parseInt(col, 16);
    var r = (num >> 16) + amt;
    if (r > 255)
        r = 255;
    else if (r < 0)
        r = 0;
    var b = ((num >> 8) & 0x00FF) + amt;
    if (b > 255)
        b = 255;
    else if (b < 0)
        b = 0;
    var g = (num & 0x0000FF) + amt;
    if (g > 255)
        g = 255;
    else if (g < 0)
        g = 0;
    return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
}
exports.lightenDarkenColor = lightenDarkenColor;
function getDashStyles() {
    return [
        'Solid',
        'ShortDash',
        'ShortDot',
        'ShortDashDot',
        'ShortDashDotDot',
        'Dot',
        'Dash',
        'LongDash',
        'DashDot',
        'LongDashDot',
        'LongDashDotDot'
    ];
}
exports.getDashStyles = getDashStyles;
var Component = function (options) {
    return function (controller) { return angular.extend(options, { controller: controller }); };
};
exports.Component = Component;
function exportHTML(html, title) {
    var header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
        "xmlns:w='urn:schemas-microsoft-com:office:word' " +
        "xmlns='http://www.w3.org/TR/REC-html40'>" +
        "<head><meta charset='utf-8'><title>Export HTML to Word Document with JavaScript</title></head><body>";
    var footer = "</body></html>";
    var sourceHTML = header + html + footer;
    var source = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(sourceHTML);
    var fileDownload = document.createElement("a");
    document.body.appendChild(fileDownload);
    fileDownload.href = source;
    fileDownload.download = title + '_' + getDate() + '.doc';
    fileDownload.click();
    document.body.removeChild(fileDownload);
}
exports.exportHTML = exportHTML;
function getDate(timestamp) {
    if (timestamp === void 0) { timestamp = null; }
    if (timestamp === '-') {
        return timestamp;
    }
    var date = timestamp ? new Date(timestamp) : new Date();
    var dateInString = date.toString();
    var splitTimestamp = dateInString.split(" ");
    var timeWithoutSec = splitTimestamp[4].substring(0, splitTimestamp[4].length - 3);
    var timeZone = splitTimestamp.slice(6, splitTimestamp.length);
    return "" + splitTimestamp[1] + " " + splitTimestamp[2] + " " + splitTimestamp[3] + " " + timeWithoutSec + " " + timeZone + "";
}
exports.getDate = getDate;
function settingCheck(field) {
    return field !== 'false';
}
function loadSettings(portfolioName, settingsFromWorkbench) {
    var settings = settingsFromWorkbench || {};
    var sessionSettingString = localStorage.getItem('PortfolioConfig');
    if (sessionSettingString) {
        var sessionSettings = JSON.parse(sessionSettingString)[portfolioName];
        if (sessionSettings && sessionSettings.chart) {
            settings = sessionSettings.chart;
            settings.timestampMode = sessionSettings.timestamp ?
                sessionSettings.timestamp.timestampMode : settingsFromWorkbench.timestampMode;
        }
    }
    return {
        showLabel: settingCheck(settings.showLabels),
        charsInLabel: settings.charsInLabel || 5,
        showTable: settingCheck(settings.showTable),
        decimals: settings.decimals === 'default' ? settings.defaultPrecision : settings.decimals,
        verticalDivider: settings.verticalDivider,
        showTooltip: settingCheck(settings.showTooltip),
        showChartExplanation: settingCheck(settings.showChartExplanation),
        groupByDisplay: settingCheck(settings.groupByDisplay),
        timestampMode: settings.timestampMode || 'lastRecalc'
    };
}
exports.loadSettings = loadSettings;
function handleResponsiveNess(highChartGot) {
    var sidebarElements = document.querySelectorAll('.neat-layout-sidebar');
    // Use a ResizeObserver to detect changes in each sidebar's size
    var resizeObservers = [];
    // Function to handle the sidebar resize event
    function handleSidebarResize(entries) {
        // attachResizeObserverToChart();
        entries.forEach(function (entry) {
            // Trigger a Highchart redraw for each sidebar when it resizes
            try {
                if (highChartGot) { // Assuming you have only one Highchart on the page
                    highChartGot.reflow();
                }
            }
            catch (e) {
            }
        });
    }
    // Start observing each "neat-layout-sidebar" element
    sidebarElements.forEach(function (sidebarElement) {
        var resizeObserver = new ResizeObserver(handleSidebarResize);
        resizeObserver.observe(sidebarElement);
        resizeObservers.push(resizeObserver);
    });
}
exports.handleResponsiveNess = handleResponsiveNess;
function makeChart(chartOptions, callback) {
    if (callback === void 0) { callback = undefined; }
    var highChartGot = null;
    // The language object is global and it can't be set on each chart initiation.
    Highcharts.setOptions({
        lang: {
            // removing the metric notations like thousands “k” abbreviation
            numericSymbols: null
        }
    });
    Highcharts.SVGRenderer.prototype.symbols.cross = function (x, y, w, h) {
        return ['M', x, y, 'L', x + w, y + h, 'M', x + w, y, 'L', x, y + h, 'z'];
    };
    if (Highcharts.VMLRenderer) {
        Highcharts.VMLRenderer.prototype.symbols.cross = Highcharts.SVGRenderer.prototype.symbols.cross;
    }
    if (!callback) {
        highChartGot = new Highcharts.Chart(chartOptions);
    }
    else {
        highChartGot = new Highcharts.Chart(chartOptions, callback);
    }
    // Drop-in fix for Highcharts issue #8477 on older Highcharts versions. The
    // issue is fixed since Highcharts v6.1.1.
    Highcharts.wrap(Highcharts.Axis.prototype, 'getPlotLinePath', function (proceed) {
        var path = proceed.apply(this, Array.prototype.slice.call(arguments, 1));
        if (path) {
            path.flat = false;
        }
        return path;
    });
    return highChartGot;
}
exports.makeChart = makeChart;
var BasicChartComponent = /** @class */ (function () {
    function BasicChartComponent($scope, $timeout, chartName) {
        var _this = this;
        this.$onChanges = function () {
            _this.$timeout();
        };
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.chartName = chartName;
    }
    BasicChartComponent.prototype.getAdditionalChartCallback = function () {
        return null;
    };
    BasicChartComponent.prototype.initComponent = function (event, args) {
        var ctrl = this;
        ctrl.actionMenuItem = args.actionMenuItem;
        ctrl.currentNode = args.node;
        ctrl.siblingNode = args.compareToNode;
        ctrl.settings = loadSettings(args.treeName, args.config.data.settings);
        if (ctrl.showTableOnReload &&
            (ctrl.actionMenuItem == ctrl.actionMenuItemOnReload)) {
            ctrl.settings.showTable = ctrl.showTableOnReload;
        }
        ctrl.menu = ctrl.getMenu();
        ctrl.tableData = {
            inputData: null,
            settings: ctrl.settings,
            mainNodeName: args.node.name,
            siblingNodeName: args.compareToNode ? args.compareToNode.name : null,
            reportOptions: args.reportOptions,
            excludeFilters: args.excludeFilters
        };
        ctrl.legends = {
            legends: args.config.data.legends,
            siblingLegends: args.config.data.siblingLegends
        };
        ctrl.graphs = args.config.data.data;
        if (ctrl.graphs && ctrl.graphs.length > 0) {
            if (ctrl.selectedGraph) {
                var graphName_1 = ctrl.selectedGraph.name;
                ctrl.selectedGraph = ctrl.graphs.find(function (item) { return item.name === graphName_1; }) || ctrl.graphs[0];
            }
            else {
                ctrl.selectedGraph = ctrl.graphs[0];
            }
            ctrl.drawChart();
        }
        ctrl.$timeout();
    };
    BasicChartComponent.prototype.drawChart = function () {
        var ctrl = this;
        var graphData = JSON.parse(JSON.stringify(ctrl.selectedGraph)) || [];
        ctrl.tableData.inputData = graphData;
        ctrl.tableData = JSON.parse(JSON.stringify(ctrl.tableData));
        var timestamp = ctrl.settings.timestampMode === 'lastRecalc' ? getDate(ctrl.currentNode.lastRecalc) : getDate();
        var chartOptions = ctrl.getChartOptions(graphData, {
            currentNode: ctrl.currentNode,
            chartTitle: ctrl.actionMenuItem,
            legends: ctrl.legends,
            settings: ctrl.settings,
            timestamp: timestamp
        });
        if (chartOptions.customised) {
            ctrl.makeChart(chartOptions);
        }
        else {
            var chartGot = makeChart(chartOptions, ctrl.getAdditionalChartCallback());
            handleResponsiveNess(chartGot);
        }
    };
    BasicChartComponent.prototype.exportCharts = function () {
        var ctrl = this;
        var exporter = new smartorg.r6.lib.ChartExporter("chart", "svg-canvas");
        var title = ctrl.actionMenuItem + " for " + ctrl.currentNode.name;
        exporter.exportChart(title, true);
    };
    BasicChartComponent.prototype.exportCsv = function (csvFormat) {
        if (csvFormat === void 0) { csvFormat = ''; }
        var ctrl = this;
        var filename = this.filename();
        ctrl.$scope.$broadcast('export:csv', { filename: filename, csvFormat: csvFormat });
    };
    BasicChartComponent.prototype.filename = function () {
        return this.chartName + "_" + this.currentNode.name + "_" + getDate() + ".csv";
    };
    BasicChartComponent.prototype.getMenu = function () {
        var ctrl = this;
        return [
            {
                'name': 'Display',
                'items': [{
                        'name': ctrl.settings.showTable ? 'Hide Table' : 'Show Table',
                        'toggle': ctrl.settings.showTable ? 'Show Table' : 'Hide Table',
                        'callback': function () {
                            ctrl.settings.showTable = !ctrl.settings.showTable;
                            ctrl.showTableOnReload = ctrl.settings.showTable;
                            ctrl.actionMenuItemOnReload = ctrl.actionMenuItem;
                        }
                    }]
            },
            {
                'name': 'Export',
                'items': [{
                        'name': 'Chart',
                        'callback': function () {
                            ctrl.exportCharts();
                        }
                    }, {
                        'name': 'Table',
                        'callback': function () {
                            ctrl.exportCsv();
                        }
                    }, {
                        'name': 'Table EU',
                        'callback': function () {
                            ctrl.exportCsv('EU');
                        }
                    }]
            }
        ];
    };
    BasicChartComponent.prototype.selectGraph = function () {
        this.drawChart();
    };
    ;
    return BasicChartComponent;
}());
exports.BasicChartComponent = BasicChartComponent;
//# sourceMappingURL=basic-chart.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/basic-component/basic-chart.component.js